<template>
  <div>

  </div>
</template>

<script>
import {AUTH_REGISTER_REQUEST} from '@/store/action-types';
import {stringPick,stringShuffle} from "../../shared/utils";
export default {
  name: 'TestPage',
  methods: {
    generatePassword: function() {
      let specials = '!@#$%^&*()_+{}:"<>?\|[];\',./`~';
      let lowercase = 'abcdefghijklmnopqrstuvwxyz';
      let uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let numbers = '0123456789';
      let all = specials + lowercase + uppercase + numbers;
      let password = '';
      password += stringPick(specials, 1);
      password += stringPick(lowercase, 1);
      password += stringPick(uppercase, 1);
      password += stringPick(numbers, 1);
      password += stringPick(all, 3, 10);
      password = stringShuffle(password);
      return password;
    },
    signUp: function() {

      const password = this.generatePassword();
      console.log(password);
      const password_confirm = password;
      const attributes = {
        name: 'Kolby Wittmack',
        phone_number: '4035755480',
        email: 'kwittmack@gmail.com'
      };
      const username = attributes.email;

      let reg = /[^0-9]+/g;
      attributes.phone_number = attributes.phone_number.replace(reg, '');
      attributes.phone_number = attributes.phone_number.substring(0, 10);

      return this.$store.dispatch(AUTH_REGISTER_REQUEST, {username, password, password_confirm, attributes}).then(data => {
        /*const status = this.$store.getters.getAuthenticationStatus;
        if(status === 'register__success') {
          this.$emit('onUserConfirmed', {
            customer: this.customer,
            customer_contact: this.customer_contact,
            customer_location: this.customer_location,
          });
        } else if(status === 'register__confirmation') {
          this.$emit('onUserCreated', {
            customer: this.customer,
            customer_contact: this.customer_contact,
            customer_location: this.customer_location,
          });
        } else {
          this.error = 'Something went wrong please contact an administrator';
        }*/
      }).catch(err => {
        /*const error = this.$store.getters.getAuthenticationError;
        if(error) {
          this.error = error
        } else {
          this.error = 'Something went wrong please contact an administrator';
        }*/
      });

    }
  },
  mounted() {
    this.signUp();
  }
}
</script>
